import { render } from "./profilewidget.vue?vue&type=template&id=50f5fafc"
import script from "./profilewidget.vue?vue&type=script&lang=js"
export * from "./profilewidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__